import React from 'react';
import { Link } from 'react-router-dom';
import LandingLogo from './LandingLogo';
import { useDemoModal } from './DemoModal';
import { ETHOSBOARD_CONTACT } from './landingConstants';
import { FOOTER_COLUMNS, FOOTER_TAGLINE } from './footerContent';
import './landing-eb.css';
import './landing-eb-footer.css';

// Where each footer link goes, by label. Anything not listed falls back to the href in footerContent.
const ROUTES = {
  // Platform: the Platform page
  'Skills and roles': '/platform',
  'Content and authoring': '/platform',
  'Learning and delivery': '/platform',
  EthosAI: '/platform#ethosai',
  Outcomes: '/platform',
  Governance: '/platform',
  'Mobile app': '/#mobile',
  Deployment: '/#deploy',
  // Resources
  'Skills framework': '/resources/skills-framework',
  'Interaction gallery': '/resources/interaction-gallery',
  'Report gallery': '/resources/report-gallery',
  'Guides and glossary': '/resources/guides',
  Comparisons: '/resources/comparisons',
  'Client stories': '/resources/client-stories',
  // Company
  'About Infylearn': '/company',
  Pricing: '/pricing',
  Contact: '/enquiry',
  FAQ: '/#faq',
};

const resolve = (col, item) => {
  if (item.label === 'Book a demo') return { demo: true };
  if (col.title === 'Industries') return { to: '/industries' };
  return { to: ROUTES[item.label] || item.href };
};

const FooterLink = ({ to, children }) => {
  const onClick = (e) => {
    const [path, hash] = to.split('#');
    const here = window.location.pathname.replace(/\/+$/, '') || '/';
    if (hash && path === here) {
      // already on that page: scroll to the section instead of navigating
      const el = document.querySelector(`#${hash}`);
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    } else if (!hash) {
      window.scrollTo(0, 0);
    }
  };
  return <Link to={to} onClick={onClick}>{children}</Link>;
};

const LandingFooter = () => {
  const { openDemo } = useDemoModal();
  const demoClick = (e) => { e.preventDefault(); openDemo(); };

  return (
    <footer className="eb eb-footer mt-auto">
      <div className="eb-footer-inner">
        <div className="eb-footer-grid">
          <div className="eb-footer-brand">
            <div className="eb-footer-logo">
              <LandingLogo variant="dark" to={null} size="md" />
            </div>
            <p className="eb-footer-tagline">{FOOTER_TAGLINE}</p>
            <a href="/enquiry" onClick={demoClick} className="landing-btn-primary eb-btn-gold eb-footer-cta text-decoration-none">
              Book a demo
            </a>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <nav key={col.title} className="eb-footer-col" aria-label={col.title}>
              <h6>{col.title}</h6>
              <ul className="list-unstyled mb-0">
                {col.items.map((item) => {
                  const r = resolve(col, item);
                  return (
                    <li key={item.label}>
                      {r.demo
                        ? <a href="/enquiry" onClick={demoClick}>{item.label}</a>
                        : <FooterLink to={r.to}>{item.label}</FooterLink>}
                    </li>
                  );
                })}
              </ul>
            </nav>
          ))}
        </div>

        <hr />
        <div className="eb-footer-bottom">
          <span>© {new Date().getFullYear()} Infylearn Technologies · Sharjah, UAE · Mumbai, India</span>
          <span className="eb-footer-legal">
            <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy</Link>
            <Link to="/terms-of-use" onClick={() => window.scrollTo(0, 0)}>Terms</Link>
            <a href={`mailto:${ETHOSBOARD_CONTACT.salesEmail}`}>{ETHOSBOARD_CONTACT.salesEmail}</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
